import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

// The variant factory is exported so links can share the exact button treatment.
// eslint-disable-next-line react-refresh/only-export-components
export const buttonVariants = cva(
  'button focus-ring inline-flex items-center justify-center gap-2 whitespace-nowrap font-semibold disabled:pointer-events-none disabled:opacity-55',
  {
    variants: {
      variant: {
        primary: 'button--primary',
        secondary: 'button--secondary',
        outline: 'button--outline',
        ghost: 'button--ghost',
        danger: 'button--danger',
      },
      size: {
        sm: 'button--sm',
        md: 'button--md',
        lg: 'button--lg',
        icon: 'button--icon',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
);

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  ),
);
Button.displayName = 'Button';
